import { FractionalTransactionPart, Collaborator } from "./../proto/api_pb.d";
import Talk from "talkjs";
import { User } from "../proto/api_pb.js";

export const mapToTalkUser = (
  user: User | FractionalTransactionPart | Collaborator
): Talk.User =>
  new Talk.User({
    id: user.getUserId(),
    name: user.getUsername(),
    role: "artist",
  });
